import type { Locale } from 'antd/es/locale';
import esES from 'antd/locale/es_ES';
import enUS from 'antd/locale/en_US';
import spanish from './locales/es.json';
import english from './locales/en.json';

export const localePeru: Locale = {
  ...esES,
  Form: {
    ...esES.Form,
    defaultValidateMessages: {
      ...esES.Form?.defaultValidateMessages,
      required: '${label} es obligatorio',
      types: {
        email: '${label} no es un correo electrónico válido',
        number: '${label} no es un número válido',
      },
      number: {
        range: '${label} debe estar entre ${min} y ${max}',
        len: '${label} debe tener exactamente ${len} caracteres',
      },
      string: {
        len: '${label} debe tener exactamente ${len} caracteres',
        min: '${label} debe tener al menos ${min} caracteres',
        max: '${label} no puede tener más de ${max} caracteres',
        range: '${label} debe tener entre ${min} y ${max} caracteres',
      },
    },
  },
};

export const locale = {
  en: {
    name: 'English',
    locale: enUS,
    messages: english,
  },
  es: {
    name: 'Español',
    locale: localePeru,
    messages: spanish,
  },
};
